import {computed, Injectable} from '@angular/core';
import {SystemParams} from "../../models/system-params";
import {ResourceLoaderService} from "../resource-loader-service/resource-loader.service";

@Injectable({
  providedIn: 'root',
})
export class SystemParamsService extends ResourceLoaderService<SystemParams> {
  private readonly resource = "/v1/system-parameters";

  logo = computed(() => {
    const logo = this.content()?.lightLogo;
    if (logo) {
      return "data:image/png;base64," + logo;
    }
    return undefined;
  });

  name = computed(() => this.content()?.name);

  loadSystemParams() {
    this.load(this.resource);
  }
}
